function categorySlugs(card) {
  return (card.categories ?? [])
    .map((entry) => (typeof entry === 'string' ? entry : entry?.slug ?? entry?.name))
    .filter(Boolean)
    .map((value) => String(value).toLowerCase())
}

/** Client-side filter: the provider's toolkit listing takes no search param. */
export function filterToolkitCards(cards, { categoryId, query }) {
  const needle = String(query ?? '').trim().toLowerCase()
  const category = String(categoryId ?? 'all').toLowerCase()

  return cards.filter((card) => {
    if (category !== 'all' && !categorySlugs(card).includes(category)) return false
    if (!needle) return true
    return (
      card.slug.toLowerCase().includes(needle) ||
      card.title.toLowerCase().includes(needle) ||
      card.description.toLowerCase().includes(needle)
    )
  })
}
